module.exports = __webpack_public_path__ + "resources/rank_num_6.3f491f029bea9f6e.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/label/img/rank_num_6.png
// module id = 545
// module chunks = 0 1 2 3